import React, { Component } from 'react';
import * as utils from './utils';
import Img from 'components/common/Img';

const scale = 1.5;

class GroupStack extends Component {
	constructor(props) {
		super(props);
		this.state = {
			orders: [0]
		}
	}
	componentDidMount() {
		this.setState({ orders: utils.getReversedArray( this.props.list.length ) });
	}
	moveToTop = ( itemIndex ) => {
		const newOrder = utils.setIndexToHighest( this.state.orders, itemIndex );
		if (newOrder) this.setState({orders: newOrder});
	}
	findAndPromote = (e) => {
		const touch = e.touches[0];
		const el = document.elementFromPoint( touch.clientX, touch.clientY );
		if ( el && el.hasAttribute('data-index') ) this.moveToTop( el.getAttribute('data-index') );
	}
	render() {
		if ( !this.props.list ) return null;
		
		const ratios = this.props.list.map( item => (item.image.width / item.image.height) );
		const ratioSum = ratios.reduce( getSum );
		const ratioLast = ratios[ this.props.list.length-1 ];
		const excessWidth = (ratioLast/ratioSum) * (scale - 1);
		const wrapperScale = 1 / (1 + excessWidth);
		const wrapperPaddingBottom = ( 1/ (ratioSum*(1+excessWidth)) ) * scale * 100 + '%';
		const wrapperStyle = {
			position: 'relative', width: '100%', height: 0,
			paddingBottom: wrapperPaddingBottom,
			transformOrigin: '0 0',
			transform: `scale3d(${wrapperScale}, ${wrapperScale}, 1)`,
		}
		const items = this.props.list.map( (item, index) => {
			const zIndex = this.state.orders[index] || 0;
			const ratio = item.image.width / item.image.height;
			const width = (ratio / ratioSum) * 100 + '%';
			const left = (index > 0)? (ratios.slice(0,index).reduce(getSum) / ratioSum ) * 100 + '%' : 0;
			return <StackItem key={index} index={index}
				onSelect={this.moveToTop}
				image={item.image} zIndex={zIndex} width={width} left={left} />;
		} )
		return (
			<div className="Stack" style={wrapperStyle} onTouchMove={this.findAndPromote}>
				{items}
			</div>
		)
	}
}

const StackItem = ({ index, onSelect, image, zIndex, width, left }) => {
	const siStyle = {
		position: 'absolute',
		left: left,
		width: width,
		zIndex: zIndex,
		transform: `scale3d(${scale}, ${scale}, 1)`,
		transformOrigin: '0 0',
	}
	const imgStyle = {
		width: '100%', height: 'auto',
		display: 'block',
		pointerEvents: 'none',
	};
	const promoteItem = (e) => {
		onSelect( index );
	}
	return (
		<div className="StackItem" style={siStyle} data-index={index}
			onMouseEnter={promoteItem} onTouchStart={promoteItem}>
			<Img style={imgStyle} src={image.src} width={image.width} height={image.height} alt="" />
		</div>
	)
}

const getSum = (total, num) => { return total + num; }

export default GroupStack;


// WEBPACK FOOTER //
// ./src/components/Pages/Project/Chunks/Stacks/GroupStack.jsx